'use strict';

function CompleteController(
  $scope,
  $mdDialog,
  ids
) {
  $scope.ids = ids;
  $scope.save = function() {
    $mdDialog.hide({
      comments: $scope.comments,
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}
CompleteController.$inject = [
  '$scope',
  '$mdDialog',
  'ids'
];

export default CompleteController;
